export const isAuthorized = ({ userPermission, permissions }) => {
    //safe check
    if (!permissions?.length) return true;

    return permissions?.some((permission) => userPermission?.includes(permission));
};
